<template>
  <v-layout row wrap class="mx-5" v-if="dependent_visa != null && dependent_visa.length > 0">
    <v-flex class="d-flex justify-content-between" xs12>
      <confirmation-header-text icon="mdi-equal-box" text="Host Visa Details"/>
      <v-btn
          color="primary"
          dark
          dense
          small
          text
          :href="'/system/visa-requests/view/'+dependent_visa.submission_no"
      >
        View Details
      </v-btn>
    </v-flex>

    <v-flex xs3>
      <list-item-detail
          :sub_title="application_data.relation"
          title="Relation"
      />
    </v-flex>
    <v-flex xs3>
      <list-item-detail
          :sub_title="dependent_visa.visa_number"
          title="Host visa number/Submission number"
      />
    </v-flex>
    <v-flex xs3>
      <list-item-detail
          :sub_title="dependent_visa.document_number"
          title="Host passport number"
      />
    </v-flex>
    <v-flex xs3>
      <list-item-detail
          :sub_title="dependent_visa.expiry_date"
          title="Visa expiry date"
      />
    </v-flex>
    <v-flex xs3>
      <list-item-detail
          :sub_title="dependent_visa.visa_type"
          title="Visa type"
      />
    </v-flex>
    <v-flex xs3>
      <list-item-detail
          :sub_title="dependent_visa.full_name"
          title="Traveller name"
      />
    </v-flex>
    <v-flex xs3>
      <list-item-detail
          :sub_title="dependent_visa.gender"
          title="Gender"
      />
    </v-flex>
  </v-layout>
  <v-layout row wrap v-else>
    <v-flex class="d-flex justify-content-between" xs12>
      <confirmation-header-text icon="mdi-equal-box" text="Host Visa Details"/>
    </v-flex>
    <v-flex sm3 class="pl-3">
      <list-item-detail
          :sub_title="application_data.relation"
          title="Relationship"/>
    </v-flex>
    <v-flex sm3>
      <list-item-detail
          :sub_title="application_data.traveller.full_name"
          :title="' Name of '+application_data.relation"/>
    </v-flex>
    <v-flex sm3>
      <list-item-detail
          :sub_title="application_data.traveller.gender"
          :title="'Gender of '+application_data.relation"/>
    </v-flex>
    <v-flex sm3 class="pl-3">
      <list-item-detail :sub_title="application_data.traveller.document_number"
                        title="Document number"/>
    </v-flex>
    <v-flex sm3>
      <list-item-detail :sub_title="application_data.traveller.dob"
                        title="Date of birth"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ListItemDetail from "../../ListItemDetail";
import ConfirmationHeaderText from "../../ConfirmationHeaderText";

export default {
  components: {
    ListItemDetail,
    ConfirmationHeaderText
  },
  computed: {
    application_data() {
      return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
    },
    dependent_visa() {
      return this.$store.state.VisaRequestSingle.visaRequest.dependent_visa;
    }
  },
};
</script>
